"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var DocumentHead = function DocumentHead(_ref) {
  var children = _ref.children;
  return _reactDom.default.createPortal(_react.default.createElement(_react.Fragment, null, children), document.head);
};

DocumentHead.propTypes = {
  children: _propTypes.default.node.isRequired
};
var _default = DocumentHead;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/portals/DocumentHead.js
// module id = 105
// module chunks = 209 210 211 212